var _react_refresh_temp_1, _react_refresh_temp_2, _react_refresh_temp_3;
var _react_refresh_temp_4;
_react_refresh_temp_4 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState, useRef } from 'react';
import { RemoteTrackPublication } from 'livekit-client';
import { createSelector } from '@reduxjs/toolkit';
import { useAppSelector } from '../../../../store';
import './style.scss';
import { sleep } from '../../../../helpers/utils';
const roomVideoQualitySelector = createSelector(_react_refresh_temp_1 = (state) => state.roomSettings, (roomSettings) => roomSettings.roomVideoQuality);
$RefreshReg$(_react_refresh_temp_1, "roomVideoQualitySelector$createSelector");
const videoObjectFitSelector = createSelector(_react_refresh_temp_2 = (state) => state.roomSettings, (roomSettings) => roomSettings.videoObjectFit);
$RefreshReg$(_react_refresh_temp_2, "videoObjectFitSelector$createSelector");
const VideoElm = ({ track }) => {
    _react_refresh_temp_4();
    const ref = useRef(null);
    const [loaded, setLoaded] = useState();
    const roomVideoQuality = useAppSelector(roomVideoQualitySelector);
    const videoObjectFit = useAppSelector(videoObjectFitSelector);
    const [videoFit, setVideoFit] = useState(videoObjectFit);
    useEffect(() => {
        var _a;
        const el = ref.current;
        if (el) {
            (_a = track.videoTrack) === null || _a === void 0 ? void 0 : _a.attach(el);
        }
        return () => {
            var _a;
            if (el) {
                (_a = track.videoTrack) === null || _a === void 0 ? void 0 : _a.detach(el);
            }
        };
    }, [track]);
    useEffect(() => {
        if (track instanceof RemoteTrackPublication) {
            track.setVideoQuality(roomVideoQuality);
        }
    }, [roomVideoQuality, track]);
    useEffect(() => {
        if (track.trackName === 'canvas') {
            setVideoFit('contain');
        }
        else {
            setVideoFit(videoObjectFit);
        }
    }, [track, videoObjectFit]);
    const onLoadedData = () => {
        setLoaded(true);
    };
    const fullScreen = async () => {
        var _a;
        if (!document.fullscreenElement) {
            (_a = ref.current) === null || _a === void 0 ? void 0 : _a.requestFullscreen().catch((err) => {
                alert(`Error attempting to enable full-screen mode: ${err.message} (${err.name})`);
            });
        }
        else {
            await document.exitFullscreen();
        }
    };
    const pictureInPicture = async () => {
        if (document.pictureInPictureElement) {
            await document.exitPictureInPicture();
            await sleep(500);
        }
        const el = ref.current;
        if (el) {
            await el.requestPictureInPicture();
        }
    };
    return (_jsxs("div", { className: "camera-video-player", children: [!loaded ? (_jsx("div", { className: "loading absolute text-center top-3 z-[999] left-0 right-0 m-auto", children: _jsxs("div", { className: "lds-ripple", children: [_jsx("div", { className: "border-secondaryColor" }), _jsx("div", { className: "border-secondaryColor" })] }) })) : null, _jsx("button", { className: "absolute z-[999] top-2 right-2 p-1 bg-black/50 w-6 h-6 flex", onClick: fullScreen, children: _jsx("i", { className: "icon pnm-fullscreen text[14px] text-white" }) }), document.pictureInPictureEnabled ? (_jsx("button", { className: "absolute z-[999] top-2 right-10 p-1 bg-black/50 w-6 h-6 flex", onClick: pictureInPicture, children: _jsx("i", { className: "icon pnm-pip text[14px] text-white" }) })) : null, _jsx("video", { className: "camera-video", onLoadedData: onLoadedData, ref: ref, style: { objectFit: videoFit } })] }));
};
_react_refresh_temp_3 = VideoElm;
$RefreshReg$(_react_refresh_temp_3, "VideoElm");
_react_refresh_temp_4(VideoElm, "H+SXfjqyBBUURSpHT/OMPBUzmjY=", false, () => [useAppSelector, useAppSelector]);
export default VideoElm;
